import { useCallback } from 'react';
import * as Immutable from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import { useAppDispatch } from '../useAppDispatch';
import { PublishProductListings } from '../../../UserData/_actions/Store/StoreProductPublishJobActions';
import ListingStore from '../../../UserData/_stores/Store/ListingStore';
import type { ProductPublishResponse } from '../../../UserData/_stores/Store/ProductPublish/ProductPublishSummaryStore';

type Options = {
	onSuccess?: (response: ProductPublishResponse) => void
	squarespaceStorePageId?: string
}

export default function usePublishListings() {
	const dispatch = useAppDispatch()

	return useCallback((
		store: string,
		listings: Immutable.Map<string, ListingStore>,
		options: Options = {}
	) => {
		let preparedListings = listings;

		if (store === 'squarespace' && options.squarespaceStorePageId) {
			preparedListings = listings.withMutations((tmpListings) => {
				tmpListings.forEach((listing, key) => {
					tmpListings.set(key, listing.set('squarespace_store_page_id', options.squarespaceStorePageId));
				});
			});
		}

		const jsonData = JSON.stringify({
			batch_id: uuidv4(),
			products: preparedListings.toJS()
		});

		dispatch(PublishProductListings(store, jsonData).set({
			onSuccess: (response) => {
				options.onSuccess?.(response.data);
			},
		}));
	}, [dispatch])
}
